import { loadSelectItems } from "#/admin/legacy/sp-select/load-select-items.js";
import "#legacy/admin/page_builder/tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function () {
  "use strict";

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "ajax-select",

    /**
     * @description The template file to use to load and render the component.
     * @see title-editor-template.hbs
     */
    templateId: "ajax-select-template",

    render: function (element, context, config) {
      var attributeConfig = config || {};
      var section = attributeConfig.section;
      var context = context || attributeConfig.default;

      var dataUrl = formatDataUrl(attributeConfig.data_url, context, section);
      var markup = this.template({ context: context, config: attributeConfig });
      element.innerHTML = markup;

      const select = element.querySelector("sp-select");

      select.multiple = Boolean(attributeConfig.multiselect);
      select.selectedTags = select.multiple;
      select.selectionClearable = select.multiple;
      select.placeholder = attributeConfig.placeholder || "";

      loadSelectItems(select, dataUrl.toString(), {
        selected: context,
        includeBlank: !attributeConfig.multiselect && (!attributeConfig.required || context == null || context === ""),
        section: section,
        defaultChoice: attributeConfig.multiselect ? attributeConfig.default : undefined,
        allPages: dataUrl.searchParams.has("offset"),
      });

      function formatDataUrl(url, initialValue, section) {
        var dataUrl = new URL(url, window.location.href);

        if (window.RESOURCE) {
          dataUrl.searchParams.set("resource_type", window.RESOURCE.type);
          dataUrl.searchParams.set("resource_id", window.RESOURCE.id);
        }

        if (section) {
          dataUrl.searchParams.set("sections", section);
        }

        if (initialValue) {
          dataUrl.searchParams.set("current", initialValue);
        }

        return dataUrl;
      }

      this.configureCustomization(element, context);
    },

    /**
     * @name bind
     * @description
     * Bind the different event listeners to the component
     * @param {HTMLElement} component
     */
    bind: function (component) {
      const select = this.element.querySelector("sp-select");

      this.handleSelectionChange = function saveSelection() {
        const value = select.value;
        component.save(select.multiple ? value : (value ?? ""));
        component.render();
      };

      select.addEventListener("change", this.handleSelectionChange);
    },

    /**
     * @name bind
     * @description
     * Unbind the different event listeners to the component added during the
     *  initial bind step.
     * @param {HTMLElement} element
     */
    unbind: function () {
      this.element.querySelector("sp-select")?.removeEventListener("change", this.handleSelectionChange);
    },
  });
})();
